// For use with ProductListingFilter
export const colorSwatches = {
  Black: '#000',
  Blue: 'rgb(41, 80, 192);',
  Brown: 'rgb(186, 153, 131)',
  Green: 'rgb(70, 208, 96)',
  Grey: 'rgb(183, 182, 182)',
  Multi: 'url(/static/images/taste-the-rainbow.jpg)',
  Orange: 'rgb(255, 149, 103)',
  Pink: 'rgb(253, 200, 229)',
  Purple: 'rgb(185, 172, 232)',
  Red: 'rgb(253, 62, 62)',
  White: 'rgb(255, 255, 255)',
  Yellow: 'rgb(255, 241, 86)',
  Gold: 'rgb(255, 215, 0)',
  Silver: 'rgb(192,192,192)',
};
